import { css } from 'styled-components';
import graphikCompact500woff from '../../../../client/fonts/graphikCompact/GraphikCompact-Medium-Web.woff';
import graphikCompact500woff2 from '../../../../client/fonts/graphikCompact/GraphikCompact-Medium-Web.woff2';
import graphikCompact500Italicwoff from '../../../../client/fonts/graphikCompact/GraphikCompact-MediumItalic-Web.woff';
import graphikCompact500Italicwoff2 from '../../../../client/fonts/graphikCompact/GraphikCompact-MediumItalic-Web.woff2';
import graphikCompact400woff from '../../../../client/fonts/graphikCompact/GraphikCompact-Regular-Web.woff';
import graphikCompact400woff2 from '../../../../client/fonts/graphikCompact/GraphikCompact-Regular-Web.woff2';
import graphikCompact600woff from '../../../../client/fonts/graphikCompact/GraphikCompact-Semibold-Web.woff';
import graphikCompact600woff2 from '../../../../client/fonts/graphikCompact/GraphikCompact-Semibold-Web.woff2';
const graphikCompact = css `
  /* Graphik Compact Regular */
  @font-face {
    font-display: swap;
    font-family: 'Graphik Compact';
    font-style: normal;
    font-weight: 400;
    src: url(${graphikCompact400woff2}) format('woff2'),
      url(${graphikCompact400woff}) format('woff');
  }

  /* Graphik Compact Medium */
  @font-face {
    font-display: swap;
    font-family: 'Graphik Compact';
    font-style: normal;
    font-weight: 500;
    src: url(${graphikCompact500woff2}) format('woff2'),
      url(${graphikCompact500woff}) format('woff');
  }

  /* Graphik Compact Italic */
  @font-face {
    font-display: swap;
    font-family: 'Graphik Compact';
    font-style: italic;
    font-weight: 500;
    src: url(${graphikCompact500Italicwoff2}) format('woff2'),
      url(${graphikCompact500Italicwoff}) format('woff');
  }

  /* Graphik Compact SemiBold */
  @font-face {
    font-display: swap;
    font-family: 'Graphik Compact';
    font-style: normal;
    font-weight: 600;
    src: url(${graphikCompact600woff2}) format('woff2'),
      url(${graphikCompact600woff}) format('woff');
  }
`;
export default graphikCompact;
